<script setup lang="ts">
defineProps({
  message: {
    type: String,
    default: 'Loading data...'
  }
})
</script>

<template>
  <div class="text-center py-10">
    <Icon
      name="i-heroicons-arrow-path"
      class="h-8 w-8 text-gray-400 mx-auto mb-4 animate-spin"
    />
    <p class="text-sm text-gray-500">
      {{ message }}
    </p>
  </div>
</template>
